import { render, staticRenderFns } from "./GatewayDetails.vue?vue&type=template&id=b04567e4&scoped=true&"
import script from "./GatewayDetails.vue?vue&type=script&lang=js&"
export * from "./GatewayDetails.vue?vue&type=script&lang=js&"
import style0 from "./GatewayDetails.vue?vue&type=style&index=0&id=b04567e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04567e4",
  null
  
)

export default component.exports